import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import First from '@/views/allPages/First.vue'
import Search from '@/views/allPages/Search.vue'
import Tissue from '@/views/allPages/Tissue'
import Goods from '@/views/donate/Goods'
import Benevolence from '@/views/donate/Benevolence'
import Contribution from '@/views/donate/Contribution'
import Fund from '@/views/donate/Fund'
import Maintext from '@/views/allPages/Maintext'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/home',
    name: 'home',
    component: Home,
    redirect: '/first',
    children:[
      {path:'/first',name:'first',component:First},
      {path:'/tissue',name:'tissue',component:Tissue},
      {path:'/goods',name:'goods',component:Goods},
      {path:'/benevolence',name:'benevolence',component:Benevolence},
      {path:'/contribution',name:'contribution',component:Contribution},
      {path:'/fund',name:'fund',component:Fund},
      {path:'/search',name:'search',component:Search},
      {path:'/maintext',name:'maintext',component:Maintext}
    ]
  },
  { path: '/', redirect: '/home' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    //x代表横坐标，y代表纵坐标
    return { x: 0,y: 0 };
}
})


export default router
